module.exports = __webpack_public_path__ + "static/media/20_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_02.243f6bdd.jpg";